module.exports = __webpack_public_path__ + "static/media/logo.07e5377a.png";